import React, {useState} from 'react';
import {Avatar, AvatarGroup, HStack, Box, VStack, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton} from '@chakra-ui/react';
import {TextG14} from '../../../components/typography';
import {MutualConnection} from '../../../hooks/usePublicProfile';
import UserAvatar from '../../../components/UserAvatar';
import {useNavigate} from 'react-router-dom';

interface MutualConnectionsProps {
  connections: MutualConnection[];
  totalCount: number;
}

const MutualConnections = ({connections, totalCount}: MutualConnectionsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  if (totalCount === 0) return null;

  const visibleNames = connections.slice(0, 2).map((c) => c.name);
  const remaining = totalCount - visibleNames.length;

  let text = '';
  if (visibleNames.length === 1 && remaining > 0) {
    text = `${visibleNames[0]} and ${remaining} other mutual connection${remaining > 1 ? 's' : ''}`;
  } else if (visibleNames.length === 2 && remaining > 0) {
    text = `${visibleNames[0]}, ${visibleNames[1]} and ${remaining} other mutual connection${remaining > 1 ? 's' : ''}`;
  } else if (visibleNames.length === 2) {
    text = `${visibleNames[0]} and ${visibleNames[1]}`;
  } else {
    text = visibleNames[0] || '';
  }

  return (
    <>
      <HStack
        spacing={3}
        px={4}
        py={2}
        cursor="pointer"
        _active={{bg: '#FAFAFA'}}
        onClick={() => setIsModalOpen(true)}>
        <AvatarGroup size="sm" max={3} spacing="-8px">
          {connections.slice(0, 3).map((c) => (
            <Avatar key={c.id} name={c.name} src={c.profilePhotoUrl} />
          ))}
          {remaining > 0 && <Avatar name={`+${remaining}`} bg="#E5E5E5" color="#1A1A1A" />}
        </AvatarGroup>
        <TextG14 mt="0" fontWeight="500" flex={1}>
          {text}
        </TextG14>
        <Box>
          <i className="fi fi-rr-angle-small-right" aria-hidden="true" style={{fontSize: '16px', color: '#757D84'}} />
        </Box>
      </HStack>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderTopRadius="16px" mt="10vh" mb={0}>
          <ModalHeader fontFamily="Gordita" fontWeight="700" fontSize="18px">
            Mutual Connections ({totalCount})
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody px={0} pb={6}>
            <VStack spacing={0} align="stretch">
              {connections.map((c) => (
                <HStack
                  key={c.id}
                  spacing={3}
                  px={4}
                  py={3}
                  cursor="pointer"
                  _hover={{bg: '#FAFAFA'}}
                  onClick={() => {
                    setIsModalOpen(false);
                    navigate(`/neighbor/${c.id}`);
                  }}>
                  <UserAvatar
                    user={{id: c.id, name: c.name, handle: c.handle, profilePhotoUrl: c.profilePhotoUrl} as any}
                    size="md"
                    avatar_image={c.profilePhotoUrl}
                  />
                  <TextG14 mt="0" fontWeight="600">
                    {c.name}
                  </TextG14>
                </HStack>
              ))}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MutualConnections;
